import React, { useEffect, useState } from 'react';
import './ObjectRenderer.scss';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import Swal from 'sweetalert2';
import SpecificSubModelDetails from './SpecificDetails';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const ObjectRenderer = ({ data, sendCurrentClicked, sendClick, uuid_from_main, submodel_from_main, onAction, toggleState, sendHierarchyToApp }) => {
    const [expandedKeys, setExpandedKeys] = useState({});
    const [checkedKeys, setCheckedKeys] = useState({});
    const [editable, setEditable] = useState({});

    const aasHost = process.env.REACT_APP_AAS_HOST;
    const aasWritePort = process.env.REACT_APP_AAS_WRITE_PORT;

    console.log("Which UUID", uuid_from_main, submodel_from_main, data,)

    const doTheThing = (finalFinalThing) => {
        var sixChars = finalFinalThing.substring(0, 6);

        if (sixChars.startsWith("curren")) {
            sixChars = "current";
        }
        if (sixChars.startsWith("self")) {
            sixChars = "self";
        }
        if (sixChars.startsWith("first_")) {
            sixChars = "first_seen";
        }
        if (sixChars.startsWith("id")) {
            sixChars = "id";
        }
        if (sixChars.startsWith("last_s")) {
            sixChars = "last_seen";
        }
        if (sixChars.startsWith("manufa")) {
            sixChars = "manufacturer";
        }
        if (sixChars.startsWith("memory")) {
            sixChars = "memory_slot_count";
        }
        if (sixChars.startsWith("model")) {
            sixChars = "model";
        }
        if (sixChars.startsWith("name")) {
            sixChars = "name";
        }
        if (sixChars.startsWith("proces")) {
            sixChars = "processor_slot_count";
        }
        if (sixChars.startsWith("seria")) {
            sixChars = "serial";
        }
        if (sixChars.startsWith("system")) {
            sixChars = "system.id";
        }
        if (sixChars.startsWith("versio")) {
            sixChars = "version";
        }
        if (sixChars.startsWith("bootab")) {
            sixChars = "bootable";
        }
        if (sixChars.startsWith("format")) {
            sixChars = "format";
        }
        if (sixChars.startsWith("free")) {
            sixChars = "free";
        }
        if (sixChars.startsWith("hard_d")) {
            sixChars = "hard_drive_index";
        }
        if (sixChars.startsWith("mount_")) {
            sixChars = "mount_point";
        }
        if (sixChars.startsWith("partit")) {
            sixChars = "partition_disk_index";
        }
        if (sixChars.startsWith("size")) {
            sixChars = "size";
        }
        if (sixChars.startsWith("system")) {
            sixChars = "system_id";
        }
        if (sixChars.startsWith("type")) {
            sixChars = "type";
        }
        if (sixChars.startsWith("used")) {
            sixChars = "used";
        }
        if (sixChars.startsWith("archit")) {
            sixChars = "architecture";
        }
        if (sixChars.startsWith("core_c")) {
            sixChars = "core_count";
        }
        if (sixChars.startsWith("descri")) {
            sixChars = "description";
        }
        if (sixChars.startsWith("hyper")) {
            sixChars = "hyperthreading";
        }
        if (sixChars.startsWith("alias")) {
            sixChars = "alias";
        }
        if (sixChars.startsWith("availa")) {
            sixChars = "available";
        }
        if (sixChars.startsWith("connec")) {
            sixChars = "connection";
        }
        if (sixChars.startsWith("connec")) {
            sixChars = "connection_status";
        }
        if (sixChars.startsWith("days_s")) {
            sixChars = "days_since_changed";
        }
        if (sixChars.startsWith("dhcp_e")) {
            sixChars = "dhcp_enabled";
        }
        if (sixChars.startsWith("dhcp_l")) {
            sixChars = "dhcp_lease_expires";
        }
        if (sixChars.startsWith("dhcp_l")) {
            sixChars = "dhcp_lease_obtained";
        }
        if (sixChars.startsWith("dhcp_s")) {
            sixChars = "dhcp_server";
        }
        if (sixChars.startsWith("dns_do")) {
            sixChars = "dns_domain";
        }
        if (sixChars.startsWith("dns_do")) {
            sixChars = "dns_domain_reg_enabled";
        }
        if (sixChars.startsWith("dns_ho")) {
            sixChars = "dns_host_name";
        }
        if (sixChars.startsWith("dns_se")) {
            sixChars = "dns_server";
        }
        if (sixChars.startsWith("ifadmi")) {
            sixChars = "ifadminstatus";
        }
        if (sixChars.startsWith("iflast")) {
            sixChars = "iflastchange";
        }
        if (sixChars.startsWith("ip_ena")) {
            sixChars = "ip_enabled";
        }
        if (sixChars.startsWith("mac")) {
            sixChars = "mac";
        }
        if (sixChars.startsWith("manufa")) {
            sixChars = "manufacturer";
        }
        if (sixChars.startsWith("net_in")) {
            sixChars = "net_index";
        }
        if (sixChars.startsWith("slaves")) {
            sixChars = "slaves";
        }
        if (sixChars.startsWith("speed")) {
            sixChars = "speed";
        }
        if (sixChars.startsWith("logica")) {
            sixChars = "logical_count";
        }
        if (sixChars.startsWith("physic")) {
            sixChars = "physical_count";
        }
        if (sixChars.startsWith("socket")) {
            sixChars = "socket";
        }
        if (sixChars.startsWith("bank")) {
            sixChars = "bank";
        }
        if (sixChars.startsWith("tag")) {
            sixChars = "tag";
        }
        if (sixChars.startsWith("form_f")) {
            sixChars = "form_factor";
        }
        if (sixChars.startsWith("end_of")) {
            sixChars = "end_of_life";
        }
        if (sixChars.startsWith("IsPart")) {
            sixChars = "IsPartOf";
        }
        if (sixChars.startsWith("HasPar")) {
            sixChars = "HasPart";
        }


        return sixChars;
    };
    // Initialize checkedKeys based on the data object
    useEffect(() => {
        const initializeCheckedKeys = (obj, parentKey = '') => {
            Object.entries(obj).forEach(([key, value]) => {
                const currentKey = parentKey ? `${parentKey}.${key}` : key;
                setCheckedKeys(prevKeys => ({ ...prevKeys, [currentKey]: false })); // Initialize all to unchecked
                if (typeof value === 'object' && value !== null) {
                    initializeCheckedKeys(value, currentKey); // Recursive initialization
                }
            });
        };

        initializeCheckedKeys(data);
    }, [data]);

    const toggleExpansion = (key) => {
        sendCurrentClicked(key)
        console.log("MY KEY", key, data[key])
        setExpandedKeys(prevKeys => ({
            ...prevKeys,
            [key]: !prevKeys[key]
        }));
    };

    const handleCheckboxChange = (key, isChecked) => {
        setCheckedKeys(prevKeys => {
            const updatedKeys = { ...prevKeys };

            // Update the current key
            updatedKeys[key] = isChecked;

            // Function to recursively update children based on the parent's state
            const updateChildKeys = (obj, parentKey, check) => {
                Object.keys(obj).forEach(k => {
                    const childKey = `${parentKey}.${k}`;
                    updatedKeys[childKey] = check;
                    if (typeof obj[k] === 'object' && obj[k] !== null) {
                        updateChildKeys(obj[k], childKey, check);
                    }
                });
            };

            // Get the direct children and update
            const currentObj = getObjectByKey(data, key); // Helper function to get the object by key
            if (currentObj) {
                updateChildKeys(currentObj, key, isChecked);
            }

            return updatedKeys;
        });
    };

    const logCheckedKeys = () => {
        const logValue = (key, obj) => {
            const keys = key.split('.');
            let value = obj;
            for (const k of keys) {
                if (value && typeof value === 'object') {
                    value = value[k];
                } else {
                    value = undefined;
                    break;
                }
            }
            if (value !== undefined) {
                console.log(key, value, " MOFO");
            }
        };

        Object.keys(checkedKeys).forEach((key) => {
            if (checkedKeys[key]) {
                logValue(key, data);
            }
        });
    };


    const getObjectByKey = (obj, key) => {
        const keys = key.split('.');
        let result = obj;
        for (let i = 0; i < keys.length; i++) {
            result = result[keys[i]];
            if (!result) return null;
        }
        return result;
    };
    function countCharacterOccurrences(str, char) {
        return str.split(char).length - 1;
    }


    function goToHierarchy(value) {
        console.log(value);
        sendHierarchyToApp(value);
    }

    const handleUpgradeClick = (currentKey, value) => {
        // Log the field and value when UpgradeIcon is clicked
        console.log("Field:", currentKey, "Value:", value);
        console.log("Which UUID", uuid_from_main, submodel_from_main)

        // If uuid_from_main is a full URI, use only the last path segment as the shell ID
        const shellId = uuid_from_main && /^https?:\/\//.test(uuid_from_main)
            ? uuid_from_main.split('/').filter(Boolean).pop()
            : uuid_from_main;

        if (submodel_from_main === "Nameplate" || submodel_from_main === "Documentation") {
            //alert("This is a f***ing nameplate")
            var submodelElement = {
                "modelType": {
                    "name": "Property"
                },
                "kind": "Instance",
                "value": `${value}`,//<== value
                "valueType": "string",
                "idShort": `${currentKey}`,
                "parent": {
                    "keys": [
                        {
                            "type": "Submodel",
                            "local": true,
                            "value": `${submodel_from_main}`,
                            "idType": "Custom"
                        }
                    ]
                }
            }

            console.log(submodelElement)
            var fixEdUrl = encodeURIComponent(shellId)
            var fixedSubModelElement = encodeURIComponent(`${currentKey}`)
            if (currentKey === "type" || currentKey === "uuid") {
                Swal.fire({
                    title: 'Error!',
                    text: 'Cannot update this field',
                    icon: 'error',
                    confirmButtonText: 'OK'
                })
            }
            if (currentKey === "model" && editable.model !== "") {
                var diti = {
                    "conceptDictionary": [],
                    "identification": {
                        "idType": "Custom",
                        "id": `${uuid_from_main}`//`${idShort}`
                    },
                    "idShort": `${editable.model}_${uuid_from_main}`,//`${name}`,
                    "dataSpecification": [],
                    "modelType": {
                        "name": "AssetAdministrationShell",
                    },
                    "asset": {
                        "identification": {
                            "idType": "Custom",
                            "id": `${uuid_from_main}`
                        },
                        "idShort": `${uuid_from_main}`,
                        "kind": "Instance",
                        "dataSpecification": [],
                        "modelType": {
                            "name": "Asset"
                        },
                        "category": `computer`,
                        "embeddedDataSpecifications": []
                    },
                    "embeddedDataSpecifications": [],
                    "views": [],
                    "submodels": [
                        {
                            "keys": [
                                {
                                    "type": "Submodel",
                                    "idType": "Custom",
                                    "value": "string",
                                    "local": true
                                }
                            ]
                        }
                    ],
                }

                upload(diti);

                fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${fixedSubModelElement}`, {
                    method: "PUT",
                    body: JSON.stringify(submodelElement),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => {
                        // Check if the response is OK (status in the range 200-299)
                        if (response.ok) {
                            //console.log("WE ARE HERE MF");
                            // Swal.fire({
                            //     title: 'Update Successful!',
                            //     icon: 'success',
                            //     confirmButtonText: 'Cool'
                            // })
                        } else {
                            // If not OK, get the response text and log an error
                            return response.text().then(errorText => {
                                // console.error("ERROR", response.status, errorText);
                                // Swal.fire({
                                //     title:"Update unsuccesful!",
                                //     icon: 'error',
                                //     confirmButtonText: 'Cool'
                                // })
                            });
                        }
                    })
                    .catch(error => {
                        // Handle any network or fetch-related errors
                        console.error("FETCH ERROR", error);
                    });
            }
            if (currentKey !== "type" && currentKey !== "uuid") {
                fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${fixedSubModelElement}`, {
                    method: "PUT",
                    body: JSON.stringify(submodelElement),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => {
                        // Check if the response is OK (status in the range 200-299)
                        if (response.ok) {
                            console.log("WE ARE HERE MF");
                            Swal.fire({
                                title: 'Update Successful!',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            })
                        } else {
                            // If not OK, get the response text and log an error
                            return response.text().then(errorText => {
                                console.error("ERROR", response.status, errorText);
                                Swal.fire({
                                    title: "Update unsuccesful!",
                                    icon: 'error',
                                    confirmButtonText: 'OK'
                                })
                            });
                        }
                    })
                    .catch(error => {
                        // Handle any network or fetch-related errors
                        console.error("FETCH ERROR", error);
                    });
            }

        }
        //-------------------------------------- BoM Staff ----------------------------------
        if (submodel_from_main !== "Nameplate") {
            if (currentKey.includes(".")) {
                console.log(currentKey.split('.')[0], currentKey.split('.')[1], currentKey.split('.')[2],)

                if (countCharacterOccurrences(currentKey, ".") === 2) {
                    var fixEdUrl = encodeURIComponent(shellId)
                    fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${currentKey.split(".")[0]}/${currentKey.split(".")[1]}/${currentKey.split(".")[2]}/value`, {
                        method: "PUT",
                        body: JSON.stringify(value),
                    }).then(response => {
                        // Check if the response is OK (status in the range 200-299)
                        if (response.ok) {
                            console.log(response);
                            Swal.fire({
                                title: 'Update Successful!',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            })
                            fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${currentKey.split(".")[2]}`, {
                                method: "DELETE",
                            }).then(response => { console.error("WE DELETED AS WELL THE " + currentKey.split(".")[2]) })
                        } else {
                            // If not OK, get the response text and log an error
                            return response.text().then(errorText => {
                                console.error("ERROR", response.status, errorText);
                                Swal.fire({
                                    title: "Update unsuccesful!",
                                    icon: 'error',
                                    confirmButtonText: 'OK'
                                })
                            });
                        }
                    })
                        .catch(error => {
                            // Handle any network or fetch-related errors
                            console.error("FETCH ERROR", error);
                        });
                }
                if (countCharacterOccurrences(currentKey, ".") === 1) {
                    var fixEdUrl = encodeURIComponent(shellId)
                    fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${currentKey.split(".")[0]}/${currentKey.split(".")[1]}/value`, {
                        method: "PUT",
                        body: JSON.stringify(value),
                    }).then(response => {
                        // Check if the response is OK (status in the range 200-299)
                        if (response.ok) {
                            console.log(response);
                            Swal.fire({
                                title: 'Update Successful!',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            })
                            fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/${submodel_from_main}/submodel/submodelElements/${currentKey.split(".")[1]}`, {
                                method: "DELETE",
                            }).then(response => { console.error("WE DELETED AS WELL THE " + currentKey.split(".")[1]) })
                        } else {
                            // If not OK, get the response text and log an error
                            return response.text().then(errorText => {
                                console.error("ERROR", response.status, errorText);
                                Swal.fire({
                                    title: "Update unsuccesful!",
                                    icon: 'error',
                                    confirmButtonText: 'OK'
                                })
                            });
                        }
                    })
                        .catch(error => {
                            // Handle any network or fetch-related errors
                            console.error("FETCH ERROR", error);
                        });
                }


            }
        }


    };
    async function upload(diti) {
        const rawId = diti.identification.id;
        const uploadShellId = rawId && /^https?:\/\//.test(rawId) ? rawId.split('/').filter(Boolean).pop() : rawId;
        var fixEdUrl = encodeURIComponent(uploadShellId)
        const mares = await fetch(`/aasServer/shells/${fixEdUrl}`, {
            method: "PUT",
            body: JSON.stringify(diti),
        })

        const res = await mares.status;


        if (res === 200) {
            //setReRender(current => !current)
            // const mares = await fetch(`/aasServer/shells/${fixEdUrl}/aas/submodels/Service/submodel`, {
            //   method: "PUT",
            //   body: JSON.stringify(diti2),
            // })
            // console.log(mares.json())
            //createTheAsset()
            Swal.fire({
                title: 'Update Successful!',
                icon: 'success',
                confirmButtonText: 'OK'
            })
            onAction();

        }
        else {
            Swal.fire({
                title: 'Update Unsuccessful!',
                icon: 'Error',
                confirmButtonText: 'OK'
            })
        }

    }




    const [areAllParentsHidden, setAreAllParentsHidden] = useState(false);
                    
    useEffect(() => {
        if (toggleState) {
            const allHidden = areAllTopLevelParentsHidden(data, toggleState);
            setAreAllParentsHidden(allHidden);
            console.log("Are all first-level parents hidden?", allHidden);
            //passToAppHiddenSubmodels(allHidden);

        } else {
            setAreAllParentsHidden(false); // If toggleState is false, don't consider them hidden
        }
    }, [toggleState, data]); // Track changes to toggleState and data

    const areAllTopLevelParentsHidden = (data, toggleState) => {
        if (!toggleState) return false; // If toggleState is false, parents can't be hidden (we don't hide values)
        
        // Check if all first-level parents are empty when toggleState is true
        return Object.keys(data).every(key => {
            const isEmpty = areAllChildrenEmpty(data[key]);
            return isEmpty; // Consider it "hidden" if all values are empty
        });
    };

    const areAllChildrenEmpty = (obj) => {
        if (obj === null || obj === undefined || obj === "" || obj === "N/A") return true;
        if (typeof obj !== 'object') return false;
        const vals = Object.values(obj);
        if (vals.length === 0) return true;
        return vals.every(value => areAllChildrenEmpty(value));
    };

    const renderObject = (obj, parentKey = '') => {
        const entries = Object.entries(obj);
        const objEntries = entries.filter(([, v]) => typeof v === 'object' && v !== null);
        const valEntries = entries.filter(([, v]) => typeof v !== 'object' || v === null);

        const visibleValEntries = valEntries.filter(([, value]) =>
            toggleState || (value !== null && value !== undefined && value !== "" && value !== "N/A")
        );

        return (
            <div>
                {visibleValEntries.length > 0 && (
                    <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #d3d3d3", borderRadius: "6px", overflow: "hidden", fontSize: "12px", margin: "6px 0" }}>
                        <tbody>
                            {visibleValEntries.map(([key, value]) => {
                                const currentKey = parentKey ? `${parentKey}.${key}` : key;
                                const finalthing = currentKey.substring(currentKey.indexOf(".") + 1);
                                const finalFinalthing = finalthing.substring(finalthing.indexOf(".") + 1);
                                const displayName = submodel_from_main === "HierarchicalStructures" ? doTheThing(finalFinalthing) : (finalFinalthing || key);
                                const isEmpty = value === null || value === undefined || value === "" || value === "N/A";
                                const inputVal = editable[currentKey] !== undefined ? editable[currentKey] : (value ?? "");
                                const isHierarchy = /\.(IsPartOf|HasPart|SameAs)$/.test(currentKey);

                                return (
                                    <tr key={currentKey} style={{ borderBottom: "1px solid #d3d3d3" }}
                                        onMouseEnter={e => e.currentTarget.style.background = "rgba(38,144,68,0.03)"}
                                        onMouseLeave={e => e.currentTarget.style.background = ""}
                                    >
                                        <td
                                            style={{ padding: "6px 11px", color: "#7c7c7c", fontWeight: "500", width: "44%", borderRight: "1px solid #d3d3d3", cursor: "pointer", fontSize: "12px" }}
                                            onClick={() => sendCurrentClicked(currentKey)}
                                        >
                                            {displayName}
                                        </td>
                                        <td style={{ padding: "2px 4px" }}>
                                            <input
                                                style={{
                                                    width: "100%", height: "26px", border: "none", outline: "none",
                                                    background: "transparent", padding: "0 6px",
                                                    color: isEmpty ? "#bbb" : "#202020",
                                                    fontStyle: isEmpty ? "italic" : "normal",
                                                    fontFamily: "'Courier New', monospace",
                                                    fontSize: "11.5px", fontWeight: "500",
                                                }}
                                                value={inputVal}
                                                onChange={e => setEditable(prev => ({ ...prev, [currentKey]: e.target.value }))}
                                            />
                                        </td>
                                        <td style={{ padding: "3px 6px", borderLeft: "1px solid #d3d3d3", textAlign: "center", width: "30px" }}>
                                            {!isHierarchy ? (
                                                <button
                                                    style={{ width: "20px", height: "20px", border: "1px solid #d3d3d3", borderRadius: "3px", background: "#fff", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "#269044" }}
                                                    onMouseEnter={e => { e.currentTarget.style.background = "#269044"; e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderColor = "#269044"; }}
                                                    onMouseLeave={e => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = "#269044"; e.currentTarget.style.borderColor = "#d3d3d3"; }}
                                                    onClick={() => handleUpgradeClick(currentKey, inputVal)}
                                                >
                                                    <UpgradeIcon style={{ fontSize: "13px" }} />
                                                </button>
                                            ) : (
                                                <button
                                                    style={{ width: "20px", height: "20px", border: "1px solid #d3d3d3", borderRadius: "3px", background: "#fff", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "#7c7c7c" }}
                                                    onMouseEnter={e => { e.currentTarget.style.background = "#f1f1f1"; }}
                                                    onMouseLeave={e => { e.currentTarget.style.background = "#fff"; }}
                                                    onClick={() => goToHierarchy(value)}
                                                >
                                                    <RemoveRedEyeIcon style={{ fontSize: "13px" }} />
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}

                {objEntries.map(([key, value]) => {
                    const currentKey = parentKey ? `${parentKey}.${key}` : key;
                    const isExpanded = expandedKeys[currentKey];
                    const finalthing = currentKey.substring(currentKey.indexOf(".") + 1);
                    if (!toggleState && areAllChildrenEmpty(value)) return null;
                    return (
                        <div key={currentKey}>
                            <div className={`key ${isExpanded ? 'expanded' : ''}`} onClick={() => toggleExpansion(currentKey)}>
                                <div className='inner_mapping_obj'>{finalthing || key}</div>
                            </div>
                            {isExpanded && (
                                <div className='nested-info'>
                                    {renderObject(value, currentKey)}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };

    
    return (
        <div style={{ padding: "8px 12px" }}>
            {renderObject(data)}
        </div>
    );
    
};

export default ObjectRenderer;



